<template>
  <em>
    <slot />
  </em>
</template>
